import type { DurationType } from '../domain/rates.js';

/**
 * Render work_types.invoice_narrative with placeholders.
 * Supported: {date} → DD.MM.YY, {site} → joined site names (or site_reference),
 * {notes} → job notes (expense/custom free text).
 * Half-day suffix comes from work_types.half_day_suffix (DB config), not code.
 */
export function formatNarrativeDate(isoDate: string): string {
  // isoDate is YYYY-MM-DD
  const [y, m, d] = isoDate.split('-');
  if (!y || !m || !d) return isoDate;
  return `${d}.${m}.${y.slice(2)}`;
}

export function joinSiteNames(
  siteNames: string[],
  siteReferenceFallback: string | null,
): string {
  const cleaned = siteNames.map((s) => s.trim()).filter(Boolean);
  if (cleaned.length > 0) return cleaned.join(' & ');
  return (siteReferenceFallback ?? '').trim();
}

export function renderInvoiceNarrative(args: {
  template: string;
  workDate: string;
  siteLabel: string;
  durationType: DurationType;
  halfDaySuffix: string;
  notes?: string | null;
}): string {
  let out = args.template;
  out = out.replaceAll('{date}', formatNarrativeDate(args.workDate));
  out = out.replaceAll('{site}', args.siteLabel);
  out = out.replaceAll('{notes}', (args.notes ?? '').trim());
  if (args.durationType === 'half_day' && args.halfDaySuffix) {
    out = `${out}${args.halfDaySuffix}`;
  }
  return out.trim();
}
